import { FormattedMessage } from "react-intl";
import CreateTrainingTypeIcon from "../../../components/Common/SvgIcons/ManageIcons/CreateTrainingTypeIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { admin } from "../admin/admin";
import { organizationSettings } from "../admin/organizationSettings/organizationSettings";

export const createTrainingType = {
  label: "Create Training Type",
  path: (tenantName) =>
    `${admin.path(tenantName)}/organizationSettings/createTrainingType`,
  icon: CreateTrainingTypeIcon,
  searchPlaceHolder: "Search training name",
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: organizationSettings.name,
      path: `${organizationSettings.path(tenantName)}`,
      onClick: () => navigate(organizationSettings.path(tenantName)),
    },
    {
      key: 3,
      label: createTrainingType.label,
      path: `${createTrainingType.path(tenantName)}`,
      onClick: () => navigate(`${createTrainingType.path(tenantName)}`),
    },
  ],
  columns: (handleDelete, handleEdit) => [
    {
      ID: 1,
      name: <FormattedMessage id="TRAINING_NAME_TEXT" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHACTION" /> ,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip content={<FormattedMessage id="DELETE_TXT" />} direction={"bottom"} show={row.CanDelete}>
            <span
              onClick={() => handleDelete(row.TypeId, row.Name)}
              style={{ visibility: row.CanDelete ? "visible" : "hidden" }}
            >
              <DeleteIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction={"bottom"}>
            <span onClick={() => handleEdit(row.TypeId, row.Name)}>
              <EditIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
